import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../service/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout(); // Desconmentar <<< ----------------------------------
                //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>401")
                //location.reload();
            }
            if (err.status === 403) {
                // auto logout if 403 response returned from api
                //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>403")
                this.authenticationService.logout(); // Descomentar <<< ----------------------------------
                location.reload(); // Descomentar <<< -----------------------------------
            }
            if (err.status === 0) {
                // Time Out
                err.error.message = "No se puede conectar con el servidor. Revise la configuración del firewall."
            }

            const error = err.error.message || err.statusText;
            return throwError(error);
        }));
    }
}
